import { render, staticRenderFns } from "./PayWithTransfer.vue?vue&type=template&id=24b137cf&scoped=true"
import script from "./PayWithTransfer.vue?vue&type=script&lang=js"
export * from "./PayWithTransfer.vue?vue&type=script&lang=js"
import style0 from "./PayWithTransfer.vue?vue&type=style&index=0&id=24b137cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b137cf",
  null
  
)

export default component.exports